import { type FetchAuctionAuctionBiddableByAuctionIdData } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { rpAuctions } from '../api';

type BiddableDetails = FetchAuctionAuctionBiddableByAuctionIdData['data'];

const useIsAuctionBidAllowedQueryKey = (auctionId: string) => ['isAuctionBidAllowed', auctionId];

export const useIsAuctionBidAllowedQuery = (
	params: { auctionId: string },
	options?: Omit<
		UseQueryOptions<FetchAuctionAuctionBiddableByAuctionIdData, Error, BiddableDetails>,
		'queryFn' | 'queryKey'
	>
) => {
	const { auctionId } = params;

	return useQuery<FetchAuctionAuctionBiddableByAuctionIdData, Error, BiddableDetails>({
		queryFn: async () => (await rpAuctions).fetchAuctionAuctionBiddableByAuctionId(auctionId),
		queryKey: useIsAuctionBidAllowedQueryKey(auctionId),
		select: (res: FetchAuctionAuctionBiddableByAuctionIdData): BiddableDetails => res.data,
		staleTime: 0,
		...options
	});
};
